import Backoffice from "@snark/backoffice"
import {treatMissingData} from "@/helpers/actions";

// noinspection JSUnusedLocalSymbols
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	return new (P || (P = Promise))(function (resolve, reject) {
		function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
		function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
		function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
		step((generator = generator.apply(thisArg, _arguments || [])).next());
	});
};

const context = {
};

export default {
	name: "missing_data",
	collection: "missing_data",
	idProperty: "_id",
	section: "data",
	sort: {"back":[{"field":"updatedAt","order":"desc"}]},
	backFilter: {"treatedAt":"$null"},
	viewActions: [
		{
			label: "Marquer comme traité",
			cssClass: "Good",
			action: treatMissingData,
		},
	],
	labels: {"singleTitle":"Missing Data","listTitle":"Missing Datas"},
	emptyItem: {"data":null},
	fields: [
		{
			name: "_id",
			label: "Id",
			readOnly: true,
			hideOnCreate: true,
		},
		{
			name: "type",
			label: "Type",
			formatter: Backoffice.formatters.mapping({"country": "Country", "tournament_enrichment": "Tournament Enrichment"}),
			editor: {type: "select", options: [{value: "country", label: "Country"}, {value: "tournament_enrichment", label: "Tournament Enrichment"}]},
		},
		{
			name: "name",
			label: "Name",
		},
		{
			name: "externalId",
			label: "External Id",
		},
		{
			name: "entityId",
			label: "Entity Id",
		},
		{
			name: "data",
			label: "Data",
		},
		{
			name: "treatedAt",
			label: "Treated At",
			readOnly: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
		{
			name: "createdAt",
			label: "Created At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
		{
			name: "updatedAt",
			label: "Updated At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
	],
	listColumns: [
		{
			name: "type",
			label: "Type",
			formatter: Backoffice.formatters.mapping({"country": "Country", "tournament_enrichment": "Tournament Enrichment"}),
		},
		{
			name: "name",
			label: "Name",
		},
		{
			name: "externalId",
			label: "External Id",
		},
		{
			name: "entityId",
			label: "Entity Id",
		},
		{
			name: "updatedAt",
			label: "Updated At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
	],
	loadSingle() {
		return Promise.all([
		]);
	},
};